import { Link, Stack } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { validateCoordinates } from '@sr/dto';

export interface CoordinatesFormValues {
  latitude: string;
  longitude: string;
}

const parseCoordinate = (value: string) => (value.trim() === '' ? null : Number(value.trim().replace(',', '.')));

export const fromCoordinates = (value: number | null): string => (value === null || value === undefined ? '' : String(value));

export const toCoordinates = (values: CoordinatesFormValues) => ({
  latitude: parseCoordinate(values.latitude),
  longitude: parseCoordinate(values.longitude),
});

export const validateCoordinatesFields = (values: CoordinatesFormValues) => {
  const { latitude, longitude } = toCoordinates(values);
  const error = validateCoordinates(latitude, longitude);
  return error ? { latitude: error } : {};
};

export const CoordinatesFields = () => {
  const { values } = useFormikContext<CoordinatesFormValues>();
  const { latitude, longitude } = toCoordinates(values);
  const hasValidPoint = latitude !== null && longitude !== null && !validateCoordinates(latitude, longitude);

  return (
    <Stack direction="column" spacing={1}>
      <Field name="latitude" label="Широта" component={TextField} />
      <Field name="longitude" label="Долгота" component={TextField} />
      {hasValidPoint && (
        <Link href={`https://yandex.ru/maps/?pt=${longitude},${latitude}&z=10&l=map`} target="_blank" rel="noopener noreferrer">
          Открыть на Яндекс.Картах
        </Link>
      )}
    </Stack>
  );
};
